import React, { useState, useEffect } from "react";
import Environment from "~/common/Environment";
import { getShortenedReviewerName } from "~/common/Reviews/CustomerReviewHelper";
import { ProductDetailPageResult, Templates } from "../ProductDetailPageResult";
import { GroupInStockOptions, getRepeatedProductSchemaProperties } from "./SchemaHelpers";
import { User } from "~/common/Store/models/User";
import { useProductDetailPageData } from "..";
interface Props {
  activeProduct: ProductDetailPageResult;
  user: User;
}
const ProductSchema = ({
  activeProduct,
  user
}: Props) => {
  const {
    itemNumber,
    header,
    primaryBrand,
    customerReviews,
    template,
    noticesAndWarnings,
    groupingAttributes,
    originalId,
    showEverlivingProductPage,
    isRequestAQuoteEnabled
  } = activeProduct;
  const {
    groupMembers = [],
    productTemplates: allProducts,
    isGoogleView = false
  } = useProductDetailPageData();
  const [domain, setDomain] = useState("");
  const [imageDomain, setImageDomain] = useState("");
  useEffect(() => {
    setDomain(`https://www.${Environment.domainWithEnvironment}`);
    setImageDomain(Environment.subdomain ? `https://www.${Environment.domainWithEnvironment}` : `https://cdnimg.webstaurantstore.com`);
  }, []);
  if (isRequestAQuoteEnabled) {
    return null;
  }
  const reviews = customerReviews.productReviewDetails.filter(review => review.oneToFiveStarRating > 0);
  let hasSpecialOrder = noticesAndWarnings?.isSpecialOrder;
  let groupInStockOptions: GroupInStockOptions = {};
  if (groupingAttributes.isGroupMaster) {
    const vgMembers = allProducts.filter(x => !x.groupingAttributes.isGroupMaster);
    const hasInStock = groupMembers.some(x => x.isInStock);
    const hasOutOfStock = groupMembers.some(x => !x.isInStock);
    const hasExclusive = vgMembers.some(x => x.customerExclusivity?.disallowNonMemberToPurchase);
    hasSpecialOrder = vgMembers.some(x => x.noticesAndWarnings?.isSpecialOrder);
    groupInStockOptions = {
      hasInStock,
      hasOutOfStock,
      hasExclusive,
      hasSpecialOrder
    };
  }
  const schemaProduct = {
    "@context": "https://schema.org",
    ...getRepeatedProductSchemaProperties(domain, imageDomain, activeProduct, user, isGoogleView && !user.registered, groupInStockOptions),
    productID: (template === Templates.OutletTemplate ? originalId : itemNumber).toLocaleUpperCase(),
    ...(!showEverlivingProductPage ? {
      sku: (template === Templates.OutletTemplate ? originalId : itemNumber).toLocaleUpperCase()
    } : undefined),
    brand: {
      "@type": "Brand",
      name: primaryBrand?.name || ""
    },
    aggregateRating: reviews.length > 0 ? {
      "@type": "AggregateRating",
      itemReviewed: {
        "@type": "Thing",
        name: header
      },
      reviewCount: reviews.length,
      ratingValue: customerReviews.overallRating.toFixed(1)
    } : undefined,
    review: reviews.length > 0 ? reviews.map(review => {
      return {
        "@type": "Review",
        reviewRating: {
          "@type": "Rating",
          ratingValue: review.oneToFiveStarRating
        },
        reviewBody: review.textReview.reviewText ?? "",
        author: {
          "@type": "Person",
          name: getShortenedReviewerName(review.fullName)
        },
        datePublished: new Date(review.textReview.dateSubmitted).toLocaleDateString("en-CA")
      };
    }) : undefined
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(schemaProduct)
  }} data-sentry-component="ProductSchema" data-sentry-source-file="ProductSchema.tsx" />;
};
export default ProductSchema;